import { Close, Save } from "@mui/icons-material";
import { IconButton, Stack, TextField} from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";

export default function QuestionForm({question, onSubmit, onCancel}){

    const [data, setData] = useState(null)

    useEffect(() => {

        setData({...question})

    }, [question])

    const handleSubmit = e => {
        e.preventDefault()
        return onSubmit(data)
    }

    const sx = {
        margin: 'auto', 
        p: 1,
        maxWidth: 500
    }
    
    return data && <form onSubmit={handleSubmit}>

        <Stack spacing={3} sx={sx}>

                <Stack direction='row' justifyContent='flex-end'>
                    <IconButton size='small' color='primary' type='submit'>
                        <Save/>
                    </IconButton>

                    <IconButton size='small' color='error' onClick={onCancel}>
                        <Close/>
                    </IconButton>
                </Stack>

                <TextField
                    label="Recommandation"
                    value={data.recommendation || ''}
                    onChange={e => setData({...data, recommendation: e.target.value.substring(0, 500)})}
                    inputProps={{maxLength: 500}}
                    multiline
                    minRows={3}
                />


        </Stack>

    </form>
}